import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { Column } from "simple-flexbox";
import { StyleSheet, css } from "aphrodite";
import Button from "@material-ui/core/Button";
import IconDownload from "../../assets/icon-download";
import { default_api } from "../../constants/default_api";
import CircularProgress from "@material-ui/core/CircularProgress";
import Archive from "@material-ui/icons/Archive";

const FOLDER = "message_blast_attachment/";
const IMAGE_EXT = ["png", "jpg", "jpeg", "gif", "bmp", "tiff", "ico", "webp"];
const PDF_EXT = ["pdf"];
const OFFICE_EXT = ["doc", "docx", "xls", "xlsx", "ppt", "pptx"];
const PREVIEWABLE_EXT = [...PDF_EXT, ...OFFICE_EXT, ...IMAGE_EXT];
const ZIP_EXT = ["zip"];

const GOOGLE_VIEWER = "https://docs.google.com/gview?url=";
const MS_OFFICE_VIEWER = "https://view.officeapps.live.com/op/embed.aspx?src=";

class ModalDokumenPDFMessageBlast extends Component {
    constructor(props) {
        super(props);
        this.state = {
            iframe_isLoading: true,
        };
        this.handleDownload = this.handleDownload.bind(this);
    }

    getFileUrl() {
        return default_api + "/image/show/" + FOLDER + (this.props.imgUrl || "");
    }

    getFileExtension() {
        const imgUrl = this.props.imgUrl || "";
        const parts = imgUrl.split(".");
        return parts.length > 1 ? parts.pop().toLowerCase() : "";
    }

    isPreviewable() {
        return PREVIEWABLE_EXT.includes(this.getFileExtension());
    }

    getViewerUrl(fileUrl) {
        const ext = this.getFileExtension();
        if (IMAGE_EXT.includes(ext)) {
            return fileUrl;
        }
        if (PDF_EXT.includes(ext)) {
            return GOOGLE_VIEWER + encodeURIComponent(fileUrl) + "&embedded=true";
        }
        if (OFFICE_EXT.includes(ext)) {
            return MS_OFFICE_VIEWER + encodeURIComponent(fileUrl);
        }
        return "";
    }

    isZip() {
        return ZIP_EXT.includes(this.getFileExtension());
    }

    handleDownload() {
        window.open(this.getFileUrl(), "_blank");
    }

    renderContent() {
        const fileUrl = this.getFileUrl();

        if (this.isZip()) {
            return (
                <Column horizontal="center" vertical="center" className={css(styles.zipContainer)}>
                    <Archive style={{ fontSize: 80, color: "#6c757d" }} />
                    <p className={css(styles.zipLabel)}>File ZIP</p>
                    <p className={css(styles.zipFileName)}>{this.props.imgUrl}</p>
                    <Button
                        onClick={this.handleDownload}
                        variant="contained"
                        color="primary"
                        className={css(styles.downloadButton)}
                        startIcon={<IconDownload />}
                    >
                        Download
                    </Button>
                </Column>
            );
        }

        if (this.isPreviewable()) {
            const viewerUrl = this.getViewerUrl(fileUrl);
            return (
                <Column className={css(styles.iframeWrapper)}>
                    {this.state.iframe_isLoading && (
                        <div className={css(styles.loadingWrap)}>
                            <CircularProgress size={36} color="primary" />
                        </div>
                    )}
                    {IMAGE_EXT.includes(this.getFileExtension()) ? (
                        <img src={viewerUrl} alt="preview-dokumen" width="100%" height="100%" onLoad={() => this.setState({ iframe_isLoading: false })} />
                    ) : (
                        <iframe
                            src={viewerUrl}
                            width="100%"
                            height="500px"
                            title="preview-dokumen"
                            onLoad={() => this.setState({ iframe_isLoading: false })}
                        />
                    )}
                </Column>
            );
        }

        return (
            <Column horizontal="center" vertical="center" className={css(styles.zipContainer)}>
                <p className={css(styles.zipLabel)}>Preview tidak tersedia</p>
                <Button
                    onClick={this.handleDownload}
                    variant="contained"
                    color="primary"
                    className={css(styles.downloadButton)}
                    startIcon={<IconDownload />}
                >
                    Download
                </Button>
            </Column>
        );
    }

    render() {
        return (
            <Modal
                show={this.props.show}
                onHide={this.props.onHide}
                dialogClassName="modal-width"
                aria-labelledby="contained-modal-title-vcenter"
            >
                <Modal.Header closeButton>
                    <Column>
                        <p style={{ fontSize: 20, fontWeight: 600 }}>
                            {this.props.modal_title}
                        </p>
                    </Column>
                </Modal.Header>
                <Modal.Body>
                    <Column className={css(styles.bodyModal)}>
                        {this.renderContent()}
                    </Column>
                </Modal.Body>
            </Modal>
        );
    }
}

const styles = StyleSheet.create({
    bodyModal: {
        padding: "0px 40px 40px 40px",
    },
    iframeWrapper: {
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "500px",
        width: "100%",
    },
    loadingWrap: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
    },
    zipContainer: {
        padding: 40,
        minHeight: 280,
    },
    zipLabel: {
        fontSize: 18,
        fontWeight: 600,
        color: "#495057",
        marginTop: 16,
        marginBottom: 4,
    },
    zipFileName: {
        fontSize: 14,
        color: "#6c757d",
        marginBottom: 24,
        wordBreak: "break-all",
    },
    downloadButton: {
        background: "#2CB96A 0% 0% no-repeat padding-box",
        boxShadow: "none",
    },
});

export default ModalDokumenPDFMessageBlast